import { getByName } from '../../../utils/queryParams';
import { BUCKETS } from '../../../stores/JobApplicationStore/types';

const ACTION_CONFIRMATION_MAPPING: Record<string, BUCKETS> = {
  shortlist: BUCKETS.SHORTLIST,
  notsuitable: BUCKETS.NOT_SUITABLE,
};

const getActionConfirmationFromQuery = (): BUCKETS | undefined => {
  const actionConfirmation = getByName('actionConfirmation') as string;

  return ACTION_CONFIRMATION_MAPPING[actionConfirmation];
};

export default getActionConfirmationFromQuery;
